module.exports = __webpack_public_path__ + "h5/img/certification3.34bfe228.png";